export const BRAND_NAME = 'Carboledger';
export const APP_NAME = 'Smart Balance';
export const BRAND_WORDMARK = 'carboledger';
